import { render, staticRenderFns } from "./lkuConsolidaCompany.vue?vue&type=template&id=225f9bb8"
import script from "./lkuConsolidaCompany.vue?vue&type=script&lang=js"
export * from "./lkuConsolidaCompany.vue?vue&type=script&lang=js"
import style0 from "./lkuConsolidaCompany.vue?vue&type=style&index=0&id=225f9bb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports